import { Button, Form, Input, message } from "antd";
import { useMemo, useState } from "react";
import logo from "../../imgs/home/logo.png";
import styles from "./index.module.scss";
import { useCountDown, useRequest } from "ahooks";
import { getCode, signIn } from "../../api/auth";
import { PhoneOutlined, LockOutlined } from "@ant-design/icons";
import useAuthStore from "../../store/auth";
import { useNavigate } from "react-router-dom";

const SignInType = {
  password: "password",
  code: "code",
};

/**
 * 登录
 */
export default function SignIn({ onSignUp, onReset }) {
  const navigate = useNavigate();
  const { setUserInfo } = useAuthStore();
  const [form] = Form.useForm();
  const [signInType, setSignInType] = useState(SignInType.password); // password or code

  const phoneNumber = Form.useWatch("phone", form);

  const [targetDate, setTargetDate] = useState();
  const [isSend, setIsSend] = useState(false);

  const [countDown] = useCountDown({
    targetDate,
    onEnd: () => {
      setIsSend(false);
    },
  });

  // 获取验证码
  const { runAsync: getVerifyCode } = useRequest(getCode, {
    manual: true,
  });

  // 注册
  const { runAsync: onSignIn } = useRequest(signIn, {
    manual: true,
  });

  // 验证码
  const suffixNode = useMemo(() => {
    const isValid = /^1[3456789]\d{9}$/.test(phoneNumber);
    return (
      <div>
        {isSend ? (
          <div className={styles.primary_btn}>
            {Math.round(countDown / 1000)}
          </div>
        ) : (
          <div
            className={styles.primary_btn}
            onClick={async () => {
              if (!phoneNumber) {
                message.error("请输入手机号");
              }
              if (!isValid) return;
              setIsSend(true);
              setTargetDate(Date.now() + 2 * 60 * 1000);
              try {
                await getVerifyCode({ phone: phoneNumber, codeType: "SignIn" });
                message.success("验证码发送成功");
              } catch (error) {
                console.log(error);
                message.error("验证码获取失败");
              }
            }}
          >
            获取验证码
          </div>
        )}
      </div>
    );
  }, [countDown, getVerifyCode, isSend, phoneNumber]);

  const onFinish = async (values) => {
    try {
      const res = await onSignIn({ ...values, grantType: signInType });
      setUserInfo(res.data);
      navigate("/home");
      message.success("登录成功");
    } catch (error) {
      message.error(error.message);
    }
  };

  return (
    <div className={styles.sign_in}>
      <img src={logo} alt="" />

      <div className={styles.tab_box}>
        <div
          className={`${styles.item} ${
            signInType === SignInType.password && styles.active
          }`}
          onClick={() => setSignInType(SignInType.password)}
        >
          <LockOutlined />
          密码登录
        </div>
        <div
          className={`${styles.item} ${
            signInType === SignInType.code && styles.active
          }`}
          onClick={() => setSignInType(SignInType.code)}
        >
          <PhoneOutlined />
          验证码登录
        </div>
      </div>
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          label="手机号"
          name="phone"
          layout="vertical"
          required
          rules={[
            {
              required: true,
              message: "请输入您的手机号",
            },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: "手机号格式有误",
            },
          ]}
        >
          <Input
            placeholder="请输入您的手机号"
            style={{ width: "400px", height: "48px" }}
          />
        </Form.Item>

        {signInType === SignInType.code && (
          <Form.Item
            label="验证码"
            layout="vertical"
            name="code"
            rules={[
              {
                required: true,
                message: "请输入验证码",
              },
              {
                pattern: /^\d{6}$/,
                message: "验证码格式有误",
              },
            ]}
          >
            <Input
              placeholder="请输入您的验证码"
              style={{ width: "400px", height: "48px" }}
              suffix={suffixNode}
            />
          </Form.Item>
        )}

        {signInType === SignInType.password && (
          <Form.Item
            label="输入密码"
            name="password"
            layout="vertical"
            rules={[
              {
                required: true,
                message: "请输入密码",
              },
              {
                min: 8,
                max: 16,
                message: "密码格式有误，请输入8-16位字符",
              },
            ]}
          >
            <Input.Password
              placeholder="请输入8-16位字符"
              style={{ width: "400px", height: "48px" }}
            />
          </Form.Item>
        )}

        <div className={styles.forget_btn} onClick={onReset}>
          忘记密码
        </div>

        <Form.Item
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            type="primary"
            style={{ width: "340px", height: "48px", fontSize: "20px" }}
            htmlType="submit"
          >
            登录
          </Button>
        </Form.Item>
      </Form>

      <div style={{ marginTop: "24px" }}>
        还没有账号？
        <span
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={onSignUp}
        >
          去注册
        </span>
      </div>
    </div>
  );
}
